import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    OnInit,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {MatPaginator} from "@angular/material/paginator";
import {MatSort, MatSortHeader} from "@angular/material/sort";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell, MatHeaderCellDef,
    MatHeaderRow, MatHeaderRowDef, MatNoDataRow, MatRow, MatRowDef, MatTable,
    MatTableDataSource
} from "@angular/material/table";
import {ApiService} from "../../../_services/api.service";
import {Endpoints} from "../../../endpoints";
import {LoggerService} from "../../../_services/logger.service";
import {DialogService} from "../../../_modal/dialog.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {OverlayContainer} from "@angular/cdk/overlay";
import {finalize, tap} from "rxjs";
import {environment} from "../../../../../environments/environment";
import {MatButton} from "@angular/material/button";
import {MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle} from "@angular/material/card";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {MatTooltip} from "@angular/material/tooltip";
import {DatePipe, NgForOf, NgIf} from "@angular/common";
import {TerrainDTO} from "../../../_models/terrain.dto";
import {ClientsService} from "../../../../services/client-service/clients.service";
import {HandleErrorsService} from "../../../../services/handle-erros/handle.errors.service";
import {TerrrainService} from "../../../../services/terrains-service/terrrain.service";
import {CommonResponse} from "../../../_models/Response";
import {HttpClient} from "@angular/common/http";
import {
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerModule,
    MatDatepickerToggle
} from "@angular/material/datepicker";
import {DateAdapter, MatNativeDateModule} from "@angular/material/core";
import * as L from 'leaflet'
import {CoordonneesGps} from "../../../_models/coordonnees-gps";
import {MatMenu, MatMenuTrigger} from "@angular/material/menu";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {CookieService} from "ngx-cookie-service";
import { ClientDetailsComponent } from '../../manage-clients/client-details/client-details.component';
import { ClientDto } from '../../../_models/client.dtos';
import { ExpoilataionDto } from '../../../_models/exploitation.dtos';
import { ExploitationService } from '../../../../services/exploitation-service/exploitation.service';

@Component({
    selector: 'app-clients-terrain-list',
    standalone: true,
    providers: [HttpClient, TerrrainService, ApiService, Endpoints, DialogService, ClientsService, HandleErrorsService],
    imports: [
        MatButton,
        MatCard,
        MatCardContent,
        MatCardHeader,
        MatCardSubtitle,
        MatCardTitle,
        MatCell,
        MatCellDef,
        MatColumnDef,
        MatError,
        MatFormField,
        MatHeaderCell,
        MatHeaderRow,
        MatHeaderRowDef,
        MatInput,
        MatLabel,
        MatOption,
        MatPaginator,
        MatRow,
        MatRowDef,
        MatSelect,
        MatSort,
        MatSortHeader,
        MatTable,
        MatTooltip,
        NgForOf,
        NgIf,
        ReactiveFormsModule,
        MatHeaderCellDef,
        MatNoDataRow,
        MatSuffix,
        MatDatepicker,
        MatDatepickerInput,
        MatDatepickerToggle,
        MatDatepickerModule,
        MatNativeDateModule,
        DatePipe,
        FormsModule,
        MatMenuTrigger,
        MatCheckbox,
        MatMenu,
    ],
    templateUrl: './clients-terrain-list.component.html',
    styleUrl: './clients-terrain-list.component.scss'
})
export class ClientsTerrainListComponent implements OnInit, AfterViewInit {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort
    @ViewChild('editModal') editModal: TemplateRef<any>;
    @ViewChild('viewModal') viewModal: TemplateRef<any>

    editTerrainForm: FormGroup;
    terrainForm: FormGroup;
    positionForm: FormGroup;
    clientList: ClientDto[];
    exploitationList:ExpoilataionDto[]=[];
    searchValue: string = ''
    loadingTable: boolean = true;
    dataSource = new MatTableDataSource<TerrainDTO>();
    map: L.Map
    marker: L.Marker;
    coordonnes: CoordonneesGps = new CoordonneesGps()
    icon = L.icon({
        iconUrl: 'assets/images/mapIcons/marker-icon.png',
        shadowUrl: 'assets/images/mapIcons/marker-shadow.png',
        iconSize: [25, 41], // size of the icon
        shadowSize: [41, 41], // size of the shadow
        iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
        shadowAnchor: [12, 41],  // the same for the shadow
        popupAnchor: [1, -34] // point from which the popup should open relative to the iconAnchor
    });
    mapId: string = ''
    terrainModel : TerrainDTO;

    displayedColumns: string[] = ['identification','producteur','varPlante', 'datePlantation', 'actif', 'exploitationId', 'creationDate','updateDate',];
    columns: string[] = [...this.displayedColumns];
columnLabels: Record<string, string> = {
  identification: 'Identification',
  producteur: 'Producteur',
  varPlante: 'Variété / Plante',
  datePlantation: 'Date de plantation',
  actif: 'Actif',
  exploitationId: 'Exploitation',
  creationDate: 'Date de création',
  updateDate: 'Dernière MAJ',
};
    constructor(
        private cookieService: CookieService,
        private exploitationService:ExploitationService,
        private apiService: ApiService,
        private endpoints: Endpoints,
        private loggerService: LoggerService,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private overlayContainer: OverlayContainer,
        private clientService: ClientsService,
        private terrainService: TerrrainService,
        private cdr: ChangeDetectorRef,
        private http: HttpClient,
        private dateAdapter: DateAdapter<Date>,
        private handleErrors: HandleErrorsService) {
        this.initializeEditForm();
        this.fetchClientList();
        this.initializeCreateForm()
        this.initializePositionForm()
        this.dateAdapter.setLocale('fr'); 
    }



    ngOnInit() {
        this.fetchTerrianList()
        this.getColsCookie()
        this.fetchClientList()
        this.fetchExploitationtList()
          this.terrainForm.get('clientId')?.valueChanges.subscribe(clientId => {
                if (clientId) {
                this.loadExploitationsByClient(clientId);
                } else {
                this.exploitationList = [];
                this.terrainForm.get('exploitationId')?.setValue(null);
                }
            });
    }
    loadExploitationsByClient(clientId: number) {
    this.exploitationService.fetchExploitationsByClient(clientId).subscribe({
        next: (exploitations: ExpoilataionDto[]) => {
        this.exploitationList = exploitations;
        // Reset de l'exploitation sélectionnée si le client change
        this.terrainForm.get('exploitationId')?.setValue(null);
        },
        error: (err) => {
        this.handleErrors.catchError(err);
        }
    });
    }

    fetchTerrianList() {
        this.http.get<CommonResponse>(this.endpoints.client_terrain_base_endpoint).subscribe(
            {
                next: res => {
                    console.log('API response:', res);  // Ajout du console.log pour afficher la réponse
                    if (res.status) {
                        this.dataSource.data = res.data;
                    } else {
                        console.log('Error in API response:', res.message);
                    }
                    this.loadingTable = false;
                },
                error: err => {
                    console.error('Error occurred:', err);  // Affiche l'erreur si une exception est lancée
                    this.loadingTable = false;
                }
            }
        );
    }
    
    ngAfterViewInit() {
        this.initializePaginatorAndSort();
        const overlayContainerElement = this.overlayContainer.getContainerElement();
        overlayContainerElement.style.zIndex = '2000';
    }

    initializePaginatorAndSort() {
        this.dataSource.filter = this.searchValue
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'asc';
    }

    initializeEditForm() {
        this.editTerrainForm = this.fb.group({
            id: ['', Validators.required],
            description: [''],
            producteur:[''],
            varPlante: ['', Validators.required],
            datePlantation: [''],
            actif: [true, Validators.required],
            clientId: ['', Validators.required],
            exploitationId:['',Validators.required],
            creationDate: ['',],
            updateDate: ['',],
            idCreatedBy: ['',],
            nameCreatedBy: ['',],
            identification: ['',],
            lat: [0, Validators.required],
            lon: [0, Validators.required],
        });
    }

    initializeCreateForm() {
        this.terrainForm = this.fb.group({
            description: [''],
            varPlante: ['', Validators.required],
            datePlantation: [''],
            actif: [true, Validators.required],
            clientId: ['', Validators.required],
            lat: [0, Validators.required],
            lon: [0, Validators.required],
            producteur:[''],
            exploitationId:['',Validators.required],

        });
    }

    initializePositionForm() {
        this.positionForm = this.fb.group({
            lat: ['', Validators.required],
            lon: ['', Validators.required],
        });
    }

    openEditModal(element: TerrainDTO) {
        this.editTerrainForm.patchValue(element);
        this.modalService.open(this.editModal, {ariaLabelledBy: 'modal-basic-title', size: 'xl'})
        this.mapId = 'edit-modal-map'
        this.coordonnes.latitude = element.lat
        this.coordonnes.longitude = element.lon
        this.initializeMap()

    }

    public fetchClientList() {
        this.clientService.loadClients().subscribe(
            {
                next: response => {
                    if (response.status) {
                        this.clientList = response.data;
                    }
                },
                error: err => {
                    this.handleErrors.catchError(err)
                }
            }
        );
    }
    public fetchExploitationtList() {
        this.exploitationService.fetchExploitationList().subscribe(
            {
                next: response => {
                    if (response) {
                        this.exploitationList = response;
                    }
                },
                error: err => {
                    this.handleErrors.catchError(err)
                }
            }
        );
    }

    updateTerrain() {
        if (this.editTerrainForm.valid) {
            const terrain = this.editTerrainForm.value;
            terrain.lat = this.coordonnes.latitude
            terrain.lon = this.coordonnes.longitude
            this.apiService.put(terrain, this.endpoints.client_terrain_base_endpoint, terrain.id,).pipe(
                tap((response: any) => {
                    if (response.status) {
                        let savedTerrain = response.data;
                        console.log('res : ')
                        console.log(savedTerrain)
                        this.updateTableRow(savedTerrain);
                        this.modalService.dismissAll();
                        this.dialogService.openSuceessAlert('Terrain modifé avec succee');
                    }
                }),
                finalize(() => {
                    this.initializePaginatorAndSort();
                })
            ).subscribe();

        } else {
            this.loggerService.log('invalid_form_data', this.editTerrainForm.value);
            this.dialogService.openDangerAlert('Form is invalid. Please check the fields.')
        }
    }

    openNewTerrainForm(content: any) {

        this.initializeEditForm()
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'xl'})

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                this.coordonnes.latitude = position.coords.latitude;
                this.coordonnes.longitude = position.coords.longitude;
                this.updateCoordonnees()

            }, () => {
                this.dialogService.openDangerAlert('Impossible d\'obtenir votre position');
            });
        } else {
            this.dialogService.openDangerAlert('La géolocalisation n\'est pas prise en charge par votre navigateur');
        }
        this.mapId = "map-for-new-modal"
        this.initializeMap()

    }
saveTerrain(): void {
    console.log("📌 saveTerrain called");  // Début de la fonction

    if (this.terrainForm.valid && this.coordonnes.latitude != null && this.coordonnes.longitude != null) {
        console.log("✅ Form is valid and coordinates are set");
        
        const terrain = this.terrainForm.value;
        console.log("📄 Terrain form value:", terrain);
        
        terrain.lat = this.coordonnes.latitude;
        terrain.lon = this.coordonnes.longitude;
        console.log(`🌍 Coordinates set: lat=${terrain.lat}, lon=${terrain.lon}`);

        this.terrainService.saveTerrain(terrain).subscribe({
            next: response => {
                console.log("📦 Response from saveTerrain:", response);

                let savedTerrain: TerrainDTO = response.data;
                console.log("💾 Saved terrain DTO:", savedTerrain);

                this.dataSource.data = [...this.dataSource.data, savedTerrain];
                console.log("🗃️ Updated dataSource:", this.dataSource.data);

                this.terrainForm.reset();
                console.log("🧹 Terrain form reset");

                this.modalService.dismissAll();
                console.log("❌ Modal dismissed");

                this.dialogService.openSuceessAlert('Terrain ajouté avec succès');
                console.log("🎉 Success alert displayed");
            },
            error: err => {
                console.error("⚠️ Error while saving terrain:", err);
                this.handleErrors.catchError(err);
            }
        });
    } else {
        console.warn("❌ Form invalid or coordinates missing");
        this.dialogService.openDangerAlert('Bad Request. Please Check Your Input and Submit Again!');
    }
}

    updateTableRow(updatedData: any) {
        const index = this.dataSource.data.findIndex(item => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
            this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
        }
    }

    confirmDelete(element: any) {
        this.dialogService.open('Etes-vous sûr de vouloir supprimer ce terrain ?', environment.warning_message_type, 'danger', environment.warning_icon, true)
            .then((result: any) => {
                if (result) {
                    this.deleteClient(element.id);
                }
            });
    }

    private deleteClient(id: number) {
        this.apiService.delete(id, this.endpoints.client_terrain_base_endpoint).pipe(
            tap((response: any) => {
                if (response.status) {
                    this.removeTableRow(id);
                    this.dialogService.openSuceessAlert(response.message);
                }
            }),
            finalize(() => {
                this.dataSource.paginator = this.paginator;
            })
        ).subscribe();
    }

    removeTableRow(id: number) {
        this.dataSource.data = this.dataSource.data.filter(item => item.id !== id);
        this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
    }

    applyFilter(event: Event) {
        this.searchValue = (event.target as HTMLInputElement).value.trim().toLowerCase()
        this.initializePaginatorAndSort()
    }

    openViewModel(terrain: TerrainDTO) {
        this.terrainModel = terrain
        this.cdr.detectChanges();
        this.modalService.open(this.viewModal, {ariaLabelledBy: 'modal-basic-title', size: 'xl'});
        this.mapId = 'map-view-modal'
        this.coordonnes.latitude = this.terrainModel.lat
        this.coordonnes.longitude = this.terrainModel.lon
        this.initializeMap()
    }

    initializeMap(): void {

        this.map = L.map(this.mapId).setView([this.coordonnes.latitude, this.coordonnes.longitude], 13);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '© OpenStreetMap contributors'
        }).addTo(this.map);

        this.updateCoordonnees()

        this.map.on('click', (e: any) => {

            this.coordonnes.latitude = e.latlng.lat;
            this.coordonnes.longitude = e.latlng.lng;

            this.updateCoordonnees()
        });
    }

     updateCoordonnees(){
        console.log(this.coordonnes)
        if (this.marker) {
            this.map.removeLayer(this.marker);
        }
        this.marker = L.marker([this.coordonnes.latitude, this.coordonnes.longitude], {icon: this.icon}).addTo(this.map)
            .bindPopup(`<b><strong>Point sélectionné : </strong></b><br>Lat: ${this.coordonnes.latitude}<br>Lng: ${this.coordonnes.longitude}`).openPopup();
         this.map.setView([this.coordonnes.latitude, this.coordonnes.longitude], this.map.getZoom());

     }

    handleIsAllColsSelected(event: MatCheckboxChange) {
        if (event.checked) {
            this.displayedColumns = [...this.columns]
        } else {
            this.displayedColumns = []
        }
        this.setColsCookie()
    }

    getdisplayedCol = (): string[] => {
        return [...this.displayedColumns, 'action']
    };

    // Handle individual checkbox changes
    onSelectionChange(column: string): void {
        if (this.displayedColumns.includes(column)) {
            this.displayedColumns = this.displayedColumns.filter(c => c !== column);
        } else {
            this.displayedColumns.push(column)
        }
        this.setColsCookie()
    }

    user_name = sessionStorage.getItem('user_name');

    private setColsCookie() {
        this.cookieService.set(`terrain_cols_${this.user_name}`, JSON.stringify(this.displayedColumns), {
            expires: 7,
            path: '/',
            secure: true
        });
    }

    private getColsCookie() {
        const sampleCols = this.cookieService.get(`terrain_cols_${this.user_name}`); // Get the cookie value

        if (sampleCols) {
            this.displayedColumns = JSON.parse(sampleCols); // Convert the JSON string back to an object
            console.log('Retrieved object:', sampleCols);
        }
    }
}

